import React from 'react';

// Fotos de banco licenciado (Unsplash, uso livre — https://unsplash.com/license),
// adolescentes/jovens em situações variadas: shows, esportes, dança em grupo, culto.
// Checadas manualmente uma a uma antes de entrar aqui (conteúdo apropriado, sem
// vida noturna/álcool). Trocar por fotos próprias da igreja é só substituir a lista.
const PHOTOS = [
  '1470229722913-7c0e2dbbafd3', // show
  '1544333323-ec9ed3218dd1', // esporte
  '1593896385987-16bcbf9451e5', // dança em grupo
  '1507692049790-de58290a4334', // culto
  '1524368535928-5b5e00ddc76b', // show
  '1547347298-4074fc3086f0', // esporte
  '1604954055722-7f80571fbfc3', // dança em grupo
  '1438232992991-995b7058bbb3', // culto
  '1629276301820-0f3eedc29fd0', // show
  '1576426846595-64bac8ffd3a8', // esporte
  '1588540111535-2b7ef1eb7833', // dança em grupo
  '1570786032462-2efc3ca8fccd', // culto
];

function url(id) {
  return `https://images.unsplash.com/photo-${id}?w=500&h=500&fit=crop&q=70`;
}

// Mosaico de fundo fixo, com um gradiente escuro por cima para o card de login
// (e o texto) ficarem legíveis em qualquer foto.
function LoginMosaic() {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden bg-slate-900">
      <div className="grid h-full w-full grid-cols-3 gap-0.5 sm:grid-cols-4 md:grid-cols-6">
        {PHOTOS.map((id) => (
          <div
            key={id}
            className="aspect-square bg-cover bg-center opacity-60"
            style={{ backgroundImage: `url(${url(id)})` }}
          />
        ))}
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/80 via-slate-900/70 to-slate-900/90" />
    </div>
  );
}

export default LoginMosaic;
